import { render, staticRenderFns } from "./PowerTranslateLeft.vue?vue&type=template&id=aed8ed04&scoped=true"
import script from "./PowerTranslateLeft.vue?vue&type=script&lang=js"
export * from "./PowerTranslateLeft.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aed8ed04",
  null
  
)

export default component.exports